<div class="header-styles">
  <a href="https://www.confuturo.cl" target="_self">
    <img
      class="logo"
      [src]="'assets/images/logo_home.svg' | brandAsset"
      alt="Compañía de Seguros de Vida y Rentas Vitalicias | Confuturo"
    />
  </a>
</div>
